import { useState } from 'react';

import { useNavigation, useLoaderData } from 'react-router';

import type { Person } from '../types/entities';

import { post } from '@helsenorge/framework-utils/hn-proxy-service';

import { messageRepresentationChange } from '../components/broker/broker-utils';

type UsePersonvelgerReturnType = {
  loading: boolean;
  users: Person[] | undefined;
  hasSelectedUser: boolean;
  handleSelectUser: (user: Person, onSuccess: () => void) => Promise<void>;
  errors: {
    profileError: boolean;
  };
};

const usePersonvelger = (): UsePersonvelgerReturnType => {
  const [loading, setLoading] = useState(false);
  const [profileError, setProfileError] = useState<boolean>(false);
  const [selectedUser, setSelectedUser] = useState<Person>();
  const navigation = useNavigation();
  const { users: loadedUsers } = useLoaderData();
  const handleSelectUser = async (user: Person, onSuccess: () => void): Promise<void> => {
    try {
      setLoading(true);
      setSelectedUser(user);
      await post('representasjon', 'representasjonsforhold/v1', {
        profilGuid: user?.profilGuid,
      });
      messageRepresentationChange();
      onSuccess();
    } catch {
      setProfileError(true);
    } finally {
      setLoading(false);
    }
  };

  const users = loadedUsers?.map((user: Person) => ({
    ...user,
    selected: selectedUser ? selectedUser?.profilGuid === user.profilGuid : user.selected,
  }));
  return {
    loading: navigation.state === 'loading' || loading,
    users,
    hasSelectedUser: !!selectedUser,
    handleSelectUser,
    errors: {
      profileError,
    },
  };
};

export default usePersonvelger;
